import { render, staticRenderFns } from "./mg.vue?vue&type=template&id=42b2bd27&"
import script from "./mg.vue?vue&type=script&lang=js&"
export * from "./mg.vue?vue&type=script&lang=js&"
import style0 from "./mg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports